import React, { useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import Cell from '../../Cell/Cell';
import InfoTablo from '../../InfoTablo/InfoTablo';
import { ReactComponent as MissedCallIcon } from '../../../../../resource/MissedCallIcon.svg';
import { notDraggableClass } from '../../../constants/common';
import useSipStates from '../../../../../hooks/useSipStates';
import { callDirections } from '../../../constants/callDirections';
import { setCallDirection, setSubscriber } from '../../../store/actions';
import { SipPhoneContext } from '../../../../../components/SipPhoneProvider';
import { formatPhoneNumber } from '../../../../../helpers/formatPhoneNumber';
import { phoneQueryKeys } from '../../../queries/queryKeys';
import { actions as newRequestAction } from '../../../../../containers/CreateRequest/new-request.actions';
import { Icon, Popconfirm, Tooltip } from 'antd';
import useClearListAnsweredCalls from '../../../hooks/useClearListAnsweredCalls';
import useSortedMissedCalls from '../../../hooks/useSortedMissedCalls';
import useUpdateListNotAnsweredCalls from '../../../hooks/useUpdateListNotAnsweredCalls';

const MissedCalls = ({ blockInstallationOwnerData }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const canDeleteNotAnsweredCalls = useSelector(
    (state) => state.authentication.userInfo.CanDeleteNotAnsweredCalls
  );

  const { mutateAsync: updateListNotAnsweredCalls } =
    useUpdateListNotAnsweredCalls();

  const { clearAsync, loading } = useClearListAnsweredCalls();

  const { startCall } = useContext(SipPhoneContext);

  const { isIdle } = useSipStates();

  const calls = queryClient.getQueryData(phoneQueryKeys.calls());
  const missedCalls = calls?.notAnswered;

  const sortedMissedCalls = useSortedMissedCalls(missedCalls);

  const handleRowClick = (item) => {
    const num = formatPhoneNumber({ phoneNumber: item.callerId });
    const fullName = item?.masterData?.fullName || item?.clientData?.name || '';

    if (num) {
      dispatch(
        setSubscriber({
          phone: item.phone,
          serviceCompany: item.serviceCompany,
        })
      );
      dispatch(setCallDirection(callDirections.outgoing));
      startCall(num);
      updateListNotAnsweredCalls(item.callerId)
      if (!blockInstallationOwnerData) {
        dispatch(newRequestAction.setOwnerData(fullName, num));
        dispatch(newRequestAction.applyAddrServiceCompany(item.companyId));
      }
    }
  };

  return (
    <Cell
      className={notDraggableClass}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '10px',
            alignItems: 'center',
          }}
        >
          <span>Непринятые звонки:</span>
          {canDeleteNotAnsweredCalls && (
            <Tooltip
              title="Очистить список непринятых звонков"
              overlayStyle={{ zIndex: 9999 }}
              placement="topRight"
            >
              <Popconfirm
                title="Вы уверены, что хотите очистить список непринятых звонков?"
                okText="Да"
                cancelText="Нет"
                overlayStyle={{ zIndex: 9999 }}
                onConfirm={clearAsync}
                placement="topRight"
              >
                <Icon
                  type={loading ? 'loading' : 'delete'}
                  style={{ color: 'red', fontSize: '14px' }}
                />
              </Popconfirm>
            </Tooltip>
          )}
        </div>
      }
      content={
        <InfoTablo
          insert
          onRowClick={isIdle ? handleRowClick : undefined}
          items={
            Boolean(sortedMissedCalls?.length)
              ? sortedMissedCalls.map((call) => ({
                  ...call,
                  iconType: 'missed',
                  renderIcon: ({ className }) => (
                    <MissedCallIcon className={className} />
                  ),
                }))
              : []
          }
        />
      }
    />
  );
};

export default MissedCalls;
